export default "__VITE_PUBLIC_ASSET__8119eb16__"